import request from "@/utils/request"

function resolveApiBaseUrl() {
    if (process.env.VUE_APP_API_BASE_URL) return process.env.VUE_APP_API_BASE_URL
    if (typeof window !== 'undefined') {
        const host = window.location.hostname
        const isLocal = host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host.startsWith('10.') || /^172\.(1[6-9]|2\d|3[01])\./.test(host)
        if (isLocal) return `${window.location.protocol}//${host}:8081/api/`
    }
    return 'https://enapi.fgqslc.com/api/'
}

const baseUrl = resolveApiBaseUrl()
const allRequest = {
        // Anonymous visitor and page-view tracking
        trackVisitor(data) {
            return request({
                url: baseUrl + `home/visitor/track`,
                method: 'post',
                data
            })
        },
        // Structured AI customer-service lead
        addCustomerLead(data) {
            return request({
                url: baseUrl + `home/lead/add`,
                method: 'post',
                data
            })
        },
        // 提交反馈
        addFeedback(data) {
            return request({
                url: baseUrl + `home/feedback/add`,
                method: 'post',
                data
            })
        },
        // AI customer-service chat (model credentials stay on the server)
        aiChat(data) {
            return request({
                url: baseUrl + `home/ai/chat`,
                method: 'post',
                data
            })
        },
    // 

    // 获取固定图文详情
    getNavs(data) {
        return request({
            url: baseUrl + `home/index/index`,
            method: 'post',
            data
        })
    },

    // 获取首页展示页
    getHome(data) {
        return request({
            url: baseUrl + `home/index/list`,
            method: 'post',
            data
        })
    },

    // 获取移动端首页
    getMobileHome(data) {
        return request({
            url: baseUrl + `home/mobile/list`,
            method: 'post',
            data
        })
    },


    // 移动端首页-热门车型
    mobileTypeList(data) {
        return request({
            url: baseUrl + `home/mobile/getTypeList`,
            method: 'post',
            data
        })
    },


    // 通用板块展示页
    getDetail(data) {
        return request({
            url: baseUrl + `home/index/detail`,
            method: 'post',
            data
        })
    },

    // 通用板块展示页移动端
    getMobileDetail(data) {
        return request({
            url: baseUrl + `home/mobile/detail`,
            method: 'post',
            data
        })
    },


    // 获取顶部大图
    getBanner(data) {
        return request({
            url: baseUrl + `home/base/getbanner`,
            method: 'post',
            data
        })
    },

    // 全部车型
    allCars(data) {
        return request({
            url: baseUrl + `home/index/allCars`,
            method: 'post',
            data
        })
    },

    // News
    getNews(data) {
        return request({
            url: baseUrl + `home/base/articlelist`,
            method: 'post',
            data
        })
    },

    // 某分类文章详情
    getArtInfo(data) {
        return request({
            url: baseUrl + `home/base/article`,
            method: 'post',
            data
        })
    },

    getArticle(data) {
        return request({
            url: baseUrl + `home/base/article_show`,
            method: 'post',
            data
        })
    },


    // Contact Us
    contactUs(data) {
        return request({
            url: baseUrl + `home/index/contactUs`,
            method: 'post',
            data
        })
    },


    // 服务支持
    getSupport(data) {
        return request({
            url: baseUrl + `home/index/support`,
            method: 'post',
            data
        })
    },


    // 系统配置
    getOption(data) {
        return request({
            url: baseUrl + `home/base/option`,
            method: 'post',
            data
        })
    },
    
    //首页车型列表
    getTypeList(data) {
        return request({
            url: baseUrl + `home/mobile/getTypeList`,
            method: 'post',
            data
        })
    },

    getJobChose(data) {
        return request({
            url: baseUrl + `home/ApplyJob/getSelct`,
            method: 'post',
            data
        })
    },


    getAllCates(data) {
        return request({
            url: baseUrl + `home/ApplyJob/allCates`,
            method: 'post',
            data
        })
    },

    getJobList(data) {
        return request({
            url: baseUrl + `home/ApplyJob/getList`,
            method: 'post',
            data
        })
    },

    
    getJobDetail(data) {
        return request({
            url: baseUrl + `home/ApplyJob/getDetail`,
            method: 'post',
            data
        })
    },

        
    addJobApply(data) {
        return request({
            url: baseUrl + `home/ApplyJob/addJob`,
            method: 'post',
            data
        })
    },

}

export { allRequest, baseUrl }
